export const getCursorPosition = data => {
  const { layerX, layerY } = data.evt;
  return { top: layerY, left: layerX };
};

export const isRightBttnClicked = data => {
  return data.evt.which === 3;
};

export const actionTypes = {
  deleteEvent: 'deleteEvent',
  changeRectangle: 'changeRectangle',
  markAsIn: 'markAsIn',
  markAsOut: 'markAsOut',
  createNewCut: 'createNewCut'
};
